<template>
    <div>

        <div v-if="isAudioSupported">
            Sound
            <button
            v-on:click="soundEnvToggle"
            tabindex="0"
            aria-label="Play or Pause Environment Sound"
            v-bind:aria-hidden="[ isHotspotPanelOpened ? 'true' : 'false' ]"
            v-bind:tabindex="[ isHotspotPanelOpened ? '-1' : '0' ]"
            v-bind:aria-disabled="[ isEnvironmentSoundPlaying ? 'false' : 'true' ]">
                <i v-if="!isNavMenuOpenedDelay" class="volume-white@22 size@19"></i>
                <i v-if="isNavMenuOpenedDelay" class="volume-black@22 size@19"></i>
                <span v-show="!isNavMenuOpenedDelay" class="audio-sprite" v-el:audio-sprite-white></span>
                <span v-show="isNavMenuOpenedDelay" class="audio-sprite" v-el:audio-sprite-black></span>
            </button>

            <audio v-el:audio-env loop aria-label="Environment Sound">
                <source src="/static/sound/environment.mp3" type="audio/mpeg">
            </audio>

            <audio v-el:audio-buttons-hover preload aria-label="Buttons Hover Sound">
                <source src="/static/sound/buttons-hover.mp3" type="audio/mpeg">
            </audio>

            <audio v-el:audio-buttons-click preload aria-label="Buttons Click Sound">
                <source src="/static/sound/buttons-click.mp3" type="audio/mpeg">
            </audio>

            <audio v-el:audio-hotspots-hover preload aria-label="Hotspots Hover Sound">
                <source src="/static/sound/hotspots-hover.mp3" type="audio/mpeg">
            </audio>

            <audio v-el:audio-hotspots-click preload aria-label="Hotspots Click Sound">
                <source src="/static/sound/hotspots-click.mp3" type="audio/mpeg">
            </audio>
        </div>

    </div>
</template>

<script>
    import Spritz from 'babel!../libs/spritz.js'
    import { playEnvironmentSound, stopEnvironmentSound, setSoundSupported } from '../vuex/actions'

    export default {
        vuex: {
            getters: {
                isEnvironmentSoundPlaying: state => state.isEnvironmentSoundPlaying,
                isFullscreenVideoOpened: state => state.isFullscreenVideoOpened,
                isNavMenuOpened: state => state.isNavMenuOpened,
                isNavMenuOpenedDelay: state => state.isNavMenuOpenedDelay,
                isMobileAgent: state => state.isMobileAgent,
                isSoundSupported: state => state.isSoundSupported,
                isHotspotPanelOpened: state => state.isHotspotPanelOpened
            },
            actions: {
                playEnvironmentSound,
                stopEnvironmentSound,
                setSoundSupported
            }
        },

        watch: {
            'isHotspotPanelOpened': function () {
                if (this.isEnvironmentSoundPlaying && this.isSoundSupported) {
                    if (this.isHotspotPanelOpened) {
                        this.soundEnvVolumeDown()
                    } else {
                        this.soundEnvVolumeUp()
                    }
                }
            },
            'isNavMenuOpened': function () {
                if (this.isEnvironmentSoundPlaying && this.isSoundSupported) {
                    if (this.isNavMenuOpened) {
                        this.soundEnvVolumeDown()
                    } else {
                        this.soundEnvVolumeUp()
                    }
                }
            },
            'isFullscreenVideoOpened': function () {
                if (this.isSoundSupported) {
                    if (this.isEnvironmentSoundPlaying && this.isFullscreenVideoOpened) {
                        this.soundEnvStop()
                    } else {
                        if (this.wasEnvironmentSoundPlaying) this.soundEnvPlay()
                    }
                }
            }
        },

        data: function () {
            return {
                audioSpriteWhite: false,
                audioSpriteBlack: false,

                isAudioSupported: true,
                isVolumeDown: false,
                canPlayType: false,

                soundEnvVolumeMin: 0.15,
                soundEnvVolumeMax: 0.3,
                soundFadeTime: 3500,
                soundElemsVolume: 0.25,
                wasEnvironmentSoundPlaying: true
            }
        },

        events: {
            'play-sound-once': function (identifier) {
                this.playOnce(identifier)
            }
        },

        ready: function () {
            this.canPlayType = (typeof this.$els.audioEnv.canPlayType !== 'undefined')
            this.spriteInit()
            this.soundInit()
        },

        methods: {
            'playOnce': function (identifier) {
                if (this.isSoundSupported) {
                    let audioTarget = false

                    if (identifier === 'buttons-hover') {
                        audioTarget = this.$els.audioButtonsHover
                    } else if (identifier === 'buttons-click') {
                        audioTarget = this.$els.audioButtonsClick
                    } else if (identifier === 'hotspots-hover') {
                        audioTarget = this.$els.audioHotspotsHover
                    } else if (identifier === 'hotspots-click') {
                        audioTarget = this.$els.audioHotspotsClick
                    }

                    if (!audioTarget.paused) {
                        let cloneTarget = audioTarget.cloneNode(true)
                        cloneTarget.volume = this.soundElemsVolume
                        cloneTarget.play()
                    } else {
                        audioTarget.volume = this.soundElemsVolume
                        audioTarget.play()
                    }
                }
            },

            'soundFade': function (to, ramp) {
                if (this.isSoundSupported) {
                    let volume = +parseFloat(this.$els.audioEnv.volume).toFixed(2)
                    let timing = this.soundFadeTime / Math.abs(100 / (ramp * 100))
                    let final = +parseFloat(to + ramp).toFixed(2)

                    let fade = setInterval(function () {
                        this.$els.audioEnv.volume = volume
                        // console.log('Volume: ' + volume)
                        volume = +parseFloat(volume + ramp).toFixed(2)

                        if (volume === final) {
                            clearInterval(fade)
                        }
                    }.bind(this), timing)
                }
            },

            'soundEnvPlay': function () {
                if (this.$els.audioEnv.paused) {
                    this.$set('wasEnvironmentSoundPlaying', false)
                    this.soundEnvVolumeUp(false)
                    this.$els.audioEnv.play()
                    this.playEnvironmentSound()
                } else {
                    this.$set('wasEnvironmentSoundPlaying', true)
                }
                this.spritePlay()
            },

            'soundEnvStop': function (manual = false) {
                if (!this.$els.audioEnv.paused) {
                    if (!manual) {
                        this.$set('wasEnvironmentSoundPlaying', true)
                    } else {
                        this.$set('wasEnvironmentSoundPlaying', false)
                    }
                    this.$els.audioEnv.pause()
                    this.stopEnvironmentSound()
                } else {
                    this.$set('wasEnvironmentSoundPlaying', false)
                }
                this.spriteStop()
            },

            'soundEnvToggle': function () {
                if (this.$els.audioEnv.paused) {
                    this.soundEnvPlay()
                } else {
                    this.soundEnvStop(true)
                }
            },

            'soundEnvVolumeToggle': function () {
                if (this.isVolumeDown) {
                    this.soundEnvVolumeUp()
                } else {
                    this.soundEnvVolumeDown()
                }
            },

            'soundEnvVolumeUp': function (fade = true) {
                if (fade) this.soundFade(this.soundEnvVolumeMax, 0.05)
                else this.$els.audioEnv.volume = this.soundEnvVolumeMax

                this.$set('isVolumeDown', false)
            },

            'soundEnvVolumeDown': function (fade = true) {
                if (fade) this.soundFade(this.soundEnvVolumeMin, -0.05)
                else this.$els.audioEnv.volume = this.soundEnvVolumeMin

                this.$set('isVolumeDown', true)
            },

            'soundInit': function () {
                // is Audio element supported by the browser?
                if (!this.canPlayType || this.isMobileAgent) {
                    this.$set('isAudioSupported', false)
                    this.setSoundSupported(false)
                } else {
                    this.soundEnvPlay()
                    this.$set('isAudioSupported', true)
                    this.setSoundSupported(true)
                }
            },

            'spriteInit': function () {
                this.audioSpriteWhite = Spritz({
                    container: this.$els.audioSpriteWhite,
                    src: '/static/sprites/audio-bars-white.png',
                    width: 70,
                    height: 20,
                    steps: 5,
                    rows: 1,
                    displayMode: 'fluid'
                }).init()

                this.audioSpriteBlack = Spritz({
                    container: this.$els.audioSpriteBlack,
                    src: '/static/sprites/audio-bars-black.png',
                    width: 70,
                    height: 20,
                    steps: 5,
                    rows: 1,
                    displayMode: 'fluid'
                }).init()
            },

            'spritePlay': function () {
                this.audioSpriteWhite.play(9)
                this.audioSpriteBlack.play(9)
            },

            'spriteStop': function () {
                this.audioSpriteWhite.pause()
                this.audioSpriteBlack.pause()
            }
        }
    }
</script>

<style lang="scss">
    @import '../assets/sass/global';

    .audio-sprite {
        display: inline-block;
        width: 14px;
        height: 20px;

        & > div {
            height: 100% !important;
        }
    }
</style>



// WEBPACK FOOTER //
// Sound.vue?2e4017c8